import CompactIcon from "../../../assets/compact.svg";
import type { ProductGroup } from "../../../types";

export const compact: ProductGroup = {
  id: "compact",
  title: "compact.title",
  icon: {
    src: CompactIcon,
    width: 47,
    height: 40,
  },
};
